import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Field, Input, Label, Notice, Title } from '@raro/ui';
import { useState, type FormEvent } from 'react';
import { MachineFill } from '../components/MachineFill';
import { Link, useNavigate } from 'react-router';
import { api } from '../lib/api';
import type { Organization } from '../lib/types';

export function NovaOrganizacaoPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [name, setName] = useState('');
  const [tagline, setTagline] = useState('');

  const [extra, setExtra] = useState<{ segment?: string; city?: string; state?: string; website?: string; description?: string }>({});
  const create = useMutation({
    mutationFn: async () => {
      const org = await api.post<Organization>('/organizations', { name, tagline: tagline || undefined });
      // o que a pesquisa achou além do nome e da linha entra no cadastro, para o cliente não nascer vazio
      const more = Object.fromEntries(Object.entries(extra).filter(([, v]) => v));
      if (Object.keys(more).length) await api.patch(`/organizations/${org.id}`, more).catch(() => undefined);
      return org;
    },
    onSuccess: async (org) => {
      await qc.invalidateQueries({ queryKey: ['organizations'] });
      navigate(`/projetos/novo?org=${org.id}`);
    },
  });

  const submit = (e: FormEvent) => {
    e.preventDefault();
    create.mutate();
  };

  return (
    <div className="rr-page rr-stack rr-stack--6">
      <div className="rr-stack rr-stack--2">
        <Label>Novo cliente</Label>
        <Title>quem vamos ajudar a enxergar?</Title>
      </div>
      <form className="rr-form" onSubmit={submit}>
        <MachineFill<{ name: string; tagline: string | null; segment?: string | null; city?: string | null; state?: string | null; website?: string | null; description?: string }> form="organization" research placeholder="o nome da empresa basta: Regina Festas" onFill={(r) => { if (r.name) setName(r.name); if (r.tagline) setTagline(r.tagline); setExtra({ segment: r.segment ?? undefined, city: r.city ?? undefined, state: r.state ?? undefined, website: r.website ?? undefined, description: r.description || undefined }); }} onPick={(field, text) => (field === 'tagline' ? setTagline(text) : setExtra((cur) => ({ ...cur, description: text })))} />
        {Object.values(extra).some(Boolean) && <p className="rr-faint" style={{ fontSize: 'var(--rr-text-xs)' }}>também vai para o cadastro: {[extra.segment, [extra.city, extra.state].filter(Boolean).join('/'), extra.website].filter(Boolean).join(' · ')}{extra.description ? ' · descrição' : ''}. dá para ajustar depois, no perfil do cliente.</p>}
        <Field label="Nome" htmlFor="name">
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required minLength={2} autoFocus />
        </Field>
        <Field label="Uma linha" htmlFor="tagline" hint="ex.: Artigos para festas e balões.">
          <Input id="tagline" value={tagline} onChange={(e) => setTagline(e.target.value)} />
        </Field>
        {create.isError && <Notice tone="error">{(create.error as Error).message}</Notice>}
        <div className="rr-form__actions">
          <Button variant="primary" type="submit" disabled={create.isPending}>
            criar cliente
          </Button>
          <Link to="/projetos">
            <Button variant="quiet">cancelar</Button>
          </Link>
        </div>
      </form>
    </div>
  );
}
